import { useState } from 'react';
import resignIcon from '../assets/resign-button.svg';
import styles from './ResignButton.module.css';

export interface ResignButtonProps {
  onResign: () => void;
  disabled?: boolean;
}

export function ResignButton({ onResign, disabled = false }: ResignButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleResignClick = () => {
    if (!disabled) {
      setShowConfirm(true);
    }
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    onResign();
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  if (showConfirm) {
    return (
      <div className={styles.confirmContainer} role="alertdialog" aria-label="Resign confirmation">
        <p className={styles.confirmText}>Are you sure you want to resign?</p>
        <div className={styles.confirmButtons}>
          <button
            type="button"
            className={styles.confirmYes}
            onClick={handleConfirm}
          >
            Yes
          </button>
          <button
            type="button"
            className={styles.confirmNo}
            onClick={handleCancel}
          >
            No
          </button>
        </div>
      </div>
    );
  }

  return (
    <button
      type="button"
      className={styles.resignButton}
      onClick={handleResignClick}
      disabled={disabled}
      aria-label="Resign game"
    >
      <img src={resignIcon} alt="" className={styles.icon} aria-hidden="true" />
      <span className={styles.label}>Resign</span>
    </button>
  );
}
